import * as z from "zod/v4";
import { competitorOverride } from "./competitor-override-types";

export const getCompetitorOverrides = {
  name: "getCompetitorOverrides" as const,
  input: z.object({}),
  output: z.object({ overrides: z.array(competitorOverride) }),
};
